var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuralNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 1.4,
    strokeOpacity: 0.55
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 30,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 30,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 30,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 30,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 32,
    x2: 30,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 32,
    x2: 30,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 32,
    x2: 30,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 32,
    x2: 30,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 50,
    x2: 30,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 50,
    x2: 30,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 50,
    x2: 30,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 50,
    x2: 30,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 6,
    x2: 54,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 6,
    x2: 54,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 22,
    x2: 54,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 22,
    x2: 54,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 42,
    x2: 54,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 42,
    x2: 54,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 58,
    x2: 54,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 58,
    x2: 54,
    y2: 44
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 32,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 50,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 6,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 22,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 42,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 58,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 20,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 44,
    r: 4.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuralNet);
export default __webpack_public_path__ + "static/media/neural-net.14bd0826a7c2d72e9be3281afe853676.svg";
export { ForwardRef as ReactComponent };